<template>
  <!-- Boletins -->
  <section class="py-5" :style="backgroundFundo" id="boletins">
    <div class="container-fluid text-center">
      <div class="row align-items-center justify-content-center bg-aquamarine" style="height:15vh;">
        <div class="col-md-12">
          <h1 class="text-white">BOLETINS</h1>
        </div>
      </div>

      <div class="row text-left text-dark" >
        <div class="p-2 col-md-4">
          <div class="card border border-white" v-if="statusLoadingLeitos">
            <div class="card-block text-center card-primary">
              <h3>Carregando...</h3>
            </div>
          </div>

          <div class="card border border-white" v-else>
            <div class="card-block text-center card-primary">
              <h3>Leitos de UTI</h3>
            </div>
            <div class="card-block">
              <img class="img-fluid rounded" :src="lastLeitoUti" width="100%" alt="Leitos de UTI-Sem imagem">
            </div>
            <div class="card-block text-center">
              <a class="btn btn-outline-danger btn-lg m-2" :href="lastLeitoUti" download>Download</a>
              <a class="btn btn-outline-primary btn-lg m-2" href="https://www.toledo.pr.gov.br/coe/leitosdeuti" target="_blank">Anteriores</a>
            </div>
          </div>
        </div>

        <div class="p-2 col-md-4" >
          <div class="card border border-white" v-if="statusLoadingBoletim">
              <div class="card-block text-center card-primary">
                <h3>Carregando...</h3>
              </div>
          </div>

          <div class="card border border-white" v-else>
            <div class="card-block text-center card-primary">
              <h3>Boletim Epidemiológico</h3>
            </div>
            <div class="card-block">
              <img class="img-fluid rounded" :src="lastBoletim" alt="Boletim-Sem imagem">
            </div>
            <div class="card-block text-center">
              <a class="btn btn-outline-danger btn-lg m-2" :href="lastBoletim" download>Download</a>
              <a class="btn btn-outline-primary btn-lg m-2" href="https://www.toledo.pr.gov.br/boletins" target="_blank">Anteriores</a>
            </div>
          </div>
        </div>

        <div class="p-2 col-md-4">
          <div class="card border border-white" v-if="statusLoadingResumo">
            <div class="card-block text-center card-primary">
              <h3>Carregando...</h3>
              <!---<h3>Resumo do Dia</h3>-->
            </div>

            <!--<div class="card-block  text-center">
              <h3>Boletim do dia, ainda não disponivel</h3>
            </div>
            <div class="card-block text-center">
              <a class="btn btn-outline-primary btn-lg m-2" href="https://www.toledo.pr.gov.br/boletins" target="_blank">Anteriores</a>
            </div>-->

          </div>

          <div class="card border border-white" v-else>
            <div class="card-block text-center card-primary">
              <h3>Resumo do Dia</h3>
            </div>
            <div class="card-block">
              <img class="img-fluid rounded" :src="lastResumo" alt="Resumo-Sem imagem">
            </div>
            <div class="card-block text-center">
              <a class="btn btn-outline-danger btn-lg m-2" :href="lastResumo" download>Download</a>
              <a class="btn btn-outline-primary btn-lg m-2" href="https://www.toledo.pr.gov.br/boletins" target="_blank">Anteriores</a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: "Bloco4Boletins",
  data() {
    return {
      backgroundFundo: {
        backgroundImage: `url(${require('@/assets/imagens/fundo_paco_municipal.jpg')})`,
        backgroundRepeat: 'no-repeat',
        /*backgroundColor: '#323232',*/
        backgroundPosition: 'center center',
        backgroundSize: 'cover'
      },
    }
  },
  computed: {
    statusLoadingLeitos() {
      return this.$store.state.loadingLeitos
    },
    statusLoadingBoletim() {
      return this.$store.state.loadingBoletim
    },
    statusLoadingResumo() {
      return this.$store.state.loadingResumo
    },
    lastLeitoUti() {
      if (this.$store.state.leitosUti) {
        return this.$store.state.leitosUti.link;
      } else {
        return {"data": {"link":"","data":""} }
      }
    },
    lastBoletim() {
      if (this.$store.state.boletimEpidemiologico) {
        return this.$store.state.boletimEpidemiologico.link;
      } else {
        return {"data": {"link":"","data":""} }
      }
    },
    lastResumo() {
      if (this.$store.state.boletimResumo) {
        return this.$store.state.boletimResumo.link;
      } else {
        return {"data": {"link":"","data":""} }
      }
    }
  },
}
</script>

<style>

</style>